
export enum AccessKeys {
  FeedFirstCard = "1",
  FeedStartup = "2",
  Search = "s",
  AutoComplete = "a",
  ReloadFeed = "r",
  Notification = "n",
  CreateContent = "c",
  UserMenu = "u",
  Award = "p",
}

export const APP_LAYOUT_VARS = {
  ":root": {
    "--sidebar-width": "44px",
    "--header-height": "72px",
    "--footer-height": "28px",
    "--subheader-height": "48px",
    "--menu-font-size": "16px",
    "--min-width": "800px"         // (IPAD Mini)
  }
};

export const APP_NAME = "PowerMinds";
export const APP_FOOTER_LINK = "https://micropower.ai";
export const APP_FOOTER_LINK_NAME = "MicroPower";

export const APP_PAGE_SIZE_SHORT = 5;
export const APP_PAGE_SIZE_MEDIUM = 10;
export const APP_PAGE_SIZE_DEFAULT = 20;

export const APP_CAROUSEL_PAGE_SIZE = 20;

export const APP_DEFAULT_EXPORT_PAGE_SIZE = 32767;

export const SEARCH_DELAY_DEBOUNCE = 300;
export const GLOBAL_SEARCH_DELAY_DEBOUNCE = 2000;

export const BANNER_CONTENT_HEIGHT = 90;

export const DRAWER_INFINITE_SCROLL_PAGE_SIZE = 20;
export const DRAWER_MAX_SELECTION_COUNT = 20;

export const KEYBOARD_ENTER = 13;
export const KEYBOARD_ESCAPE = 27;
export const KEYBOARD_ARROW_UP = 38;
export const KEYBOARD_ARROW_DOWN = 40;

export const VK_ENTER = "Enter";
export const VK_NUMPAD_ENTER = "NumpadEnter";
export const VK_ESCAPE = "Escape";
export const VK_TAB = "Tab";
export const VK_BACKSPACE = "Backspace";

export const FEED_CARD_WIDTH = 656;
export const FEED_CONTAINER_ID = "feedContainer";
export const FEED_RIGHT_PANEL_ID = "feedManagerRightPanel";
export const FEED_FILTER_AREA_ID = "feedContainerFilterArea";
export const FEED_CONTENT_PANELS_ID = "feedContentPanels";
export const FEED_BOX_PANELS = "feedBoxPanels";
export const FEED_PUB_HEADER = "feedPubHeader";
export const FEED_STACK_AREA = 'feedStackArea';
export const FEED_RIGHT_PANEL_WIDTH = 300;
export const FEED_RIGHT_PANEL_OFFSET_TOP = 136;

export const FIELD_NUMBER_MAXVALUE = 999999999;
export const FIELD_NUMBER_MINVALUE = -99999999;

export const LINK_CERTIFICATE_GUIDE = "/docs/CertificateGuide.pdf";
export const LINK_LOADDATA_GUIDE = "/docs/Manual de Importação de Dados.pdf";

export const FACEBOOK_LINK_PROFILE = "https://facebook.com";
export const INSTAGRAM_LINK_PROFILE = "https://instagram.com";
export const TWITTER_LINK_PROFILE = "https://x.com";
export const LINKEDIN_LINK_PROFILE = "https://linkedin.com/in";

export const REGEX_INFO_LINK = "https://pt.wikipedia.org/wiki/Expressão_regular";

export const ONE_GB = 1024 * 1024 * 1024;

export const ONE_MB = 1024 * 1024;

export const ONE_DAY_MILISECONDS = 86400000;

export const BrlCurrency = "R$";

export const IS_SAFARI = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

export const APP_STORE_GOOGLE_LINK = "https://play.google.com/store/apps/details?id=";

export const IP_API_URL = "https://ipapi.co/json/";
